import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectCountry from './SelectCountry';
import Loading from './Loading';
import { useSetUserCountry, useOnboardingStage, useSetOnboardingStage, useSignupMethod } from '../state';
import fetchWithToken, { updateOnboardingStage } from '../services';
import { ONBOARDING_ROUTES, GENERAL_ROUTES } from '../constants/routes';

const updateUserCountry = async (fetchWithToken, setIsLoading, selectedCountry, setUserCountry, navigate) => {
    setIsLoading(true);

    try {
        const response = await fetchWithToken('/update-user-country', {
            method: 'POST',
            body: JSON.stringify({ country: selectedCountry }),
        });

        if (response.ok) {
            console.log('User updated successfully');
            await setUserCountry(selectedCountry);
            setIsLoading(false);
        } else {
            console.error('Failed to update user');
            setIsLoading(false);
            navigate('/error');
        }
    } catch (error) {
        console.error('Error updating user:', error);
        setIsLoading(false);
        navigate('/error');
    }
};

const SelectCountryWrapper = () => {
    const setUserCountry = useSetUserCountry();
    const onboardingStage = useOnboardingStage();
    const setOnboardingStage = useSetOnboardingStage();
    const signupMethod = useSignupMethod();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (onboardingStage !== 'select-country') {
            navigate(GENERAL_ROUTES.HOME);
        }
    }, [onboardingStage, navigate]);

    const handleCountryChange = (countryCode) => {
        setSelectedCountry(countryCode);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            // First update the user's country
            await updateUserCountry(fetchWithToken, setIsLoading, selectedCountry, setUserCountry, navigate);
            setUserCountry(selectedCountry);

            if (signupMethod === 'google') {
                await updateOnboardingStage('enter-display-name');
                setOnboardingStage('enter-display-name');

                setIsLoading(false);
                navigate(ONBOARDING_ROUTES.ENTER_DISPLAY_NAME);
            } else {
                await updateOnboardingStage('enter-link-id');
                setOnboardingStage('enter-link-id');

                setIsLoading(false);
                navigate(ONBOARDING_ROUTES.ENTER_LINK_ID);
            }
        } catch (error) {
            console.error('Error in form submission:', error);
            setIsLoading(false);
            navigate(GENERAL_ROUTES.ERROR);
        }
    };

    if (isLoading) return <Loading />;

    return (
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh)] ml-4 mr-4">
            {/* <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto"> */}
            <form onSubmit={handleSubmit} className="p-6 max-w-md mx-auto">
                <div className="mb-4">
                    <SelectCountry
                        onCountryChange={handleCountryChange}
                    />
                </div>
                {selectedCountry && <div className="flex justify-center"><button
                    type="submit"
                    className="w-24 text-center py-2 px-4 bg-orange-200 text-black font-semibold rounded-lg hover:bg-orange-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 justify-center"
                >Continue</button>
                </div>}
            </form>
        </div>
    );
};

export default SelectCountryWrapper;